import type { GetRequestMyFilesResponse } from "@nlc/shared-types";
import type { DefaultError } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import authenticatedApi from "@/lib/api/client";

import { useIsMyFileTemplate } from "./useIsMyFileTemplate";
export function useGetRequestMyFiles() {
  const { requestId } = useSearch({ strict: false });
  const isTemplate = useIsMyFileTemplate();

  return useQuery<
    GetRequestMyFilesResponse,
    DefaultError,
    {
      id: number;
      isSourceFile: boolean;
      name: string;
      version: number | undefined;
    }[]
  >({
    enabled: !!requestId,
    queryFn: () =>
      authenticatedApi.url(`/requests/${requestId}/my-files`).get().json(),
    queryKey: ["myFiles", requestId, isTemplate],
    select: (data) =>
      data.myFiles.map((file) => ({
        id: file.attachmentId,
        isSourceFile: file.isSourceFile,
        name: file.name,
        version: file.version,
      })),
  });
}
